import { Form, Input, Space } from "antd";
import { RuleUIAction } from "models/rules";
import { FC } from "react";

/*
    When implementing new actions, the initialValue of the $IAction form item needs
    to be the verbatim type name of the backend action class (Core project, Rules/Actions.cs).
*/

export const InsertAtAction = () => <>
    <Form.Item name={['action', '$IAction']} initialValue="InsertBeforeMarkerOrAppendAction">
        <Input hidden />
    </Form.Item>
    <Space direction="vertical">
        <Form.Item
            name={['action', 'term']}
            label="Insert the term"
            rules={[{ required: true, message: "term is required!" }]}>
            <Input />
        </Form.Item>
        <Form.Item
            name={['action', 'marker']}
            label="Before the last occurrence of"
            rules={[
                { required: true, message: "insert marker is required!" },
                { max: 1, message: "only supports a single character!" }
            ]}
            initialValue='#'>
            <Input />
        </Form.Item>
    </Space>
</>;

export const RemoveAction = () => <>
    <Form.Item name={['action', '$IAction']} initialValue="RemoveAction">
        <Input hidden />
    </Form.Item>
    <Form.Item
        name={['action', 'term']}
        label="Remove all occurrences of"
        rules={[{ required: true, message: "term is required!" }]}>
        <Input />
    </Form.Item>
</>

export const ReplaceAction = () => <>
    <Form.Item name={['action', '$IAction']} initialValue="ReplaceAction">
        <Input hidden />
    </Form.Item>
    <Space direction="vertical">
        <Form.Item
            name={['action', 'term']}
            label="Replace all occcurences of"
            rules={[{ required: true, message: "term is required!" }]}>
            <Input />
        </Form.Item>
        <Form.Item
            name={['action', 'replacement']}
            label="with the term"
            rules={[{ required: true, message: "replacement is required!" }]}>
            <Input />
        </Form.Item>
    </Space>
</>;

export const DropCharsAction = () => <>
    <Form.Item name={['action', '$IAction']} initialValue="DropCharactersAction">
        <Input hidden />
    </Form.Item>
    <Form.Item
        name={['action', 'chars']}
        label="Remove any of these characters"
        rules={[{ required: true, message: "at least 1 character is required!" }]}>
        <Input />
    </Form.Item>
</>;

export const ActionMap: Record<RuleUIAction, FC> = {
    [RuleUIAction.Unknown]: () => <></>,
    [RuleUIAction.InsertAt]: InsertAtAction,
    [RuleUIAction.Remove]: RemoveAction,
    [RuleUIAction.Replace]: ReplaceAction,
    [RuleUIAction.DropChars]: DropCharsAction,
};